import { Box, Colors, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

interface Props {
  startDate: string
  endDate?: string | null
}

export const AssignationsTag = ({ startDate, endDate }: Props) => {
  const startedAt = moment(startDate)
  const endedAt = endDate ? moment(endDate) : null

  const startedBeforeToday = startedAt.isSameOrBefore(moment(), 'day')

  if (startedAt.isAfter(moment())) {
    return (
      <Tag
        text={i18n.t('finance.cost_centers.assignments.status.upcoming')}
        background="purple200"
      />
    )
  }

  if (startedBeforeToday) {
    if (endedAt === null || endedAt?.isSameOrAfter(moment(), 'day')) {
      return (
        <Tag
          text={i18n.t('finance.cost_centers.assignments.status.current')}
          background="viridian200"
        />
      )
    }
  }
}

export const Tag = ({
  background,
  textColor = 'grey1000',
  text,
}: {
  text: string
  background: Colors
  textColor?: Colors
}) => {
  return (
    <Box
      height="s24"
      background={background}
      paddingX="s8"
      borderRadius={{
        all: 'abs008',
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Text.Normal size="200" weight="medium" color={textColor}>
        {text}
      </Text.Normal>
    </Box>
  )
}
